import { Injectable, inject } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { map } from 'rxjs';

// Package.json
import packageJson from '../../../../../package.json';

// Services
import { CommonService } from '../common/common.service';
import { StorageService } from '../storage/storage.service';

// Types
import { StorageKey } from '../../../shared/types/storage';

const BASE_PATH = './assets/i18n';
const PATH_COMMON = 'common';
const PATH_PAGES = 'pages';

const SUFFIX: string = '.json?v=' + packageJson.version;

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function buildPath(PATH: string, PATH_FOLDER: string, SUBFOLDER: string = '', RESOURCE: string = ''): string {
  if (SUBFOLDER !== '') {
    return [PATH, PATH_FOLDER, SUBFOLDER, RESOURCE].join('/') + (RESOURCE !== '' ? '/' : '');
  } else {
    return [PATH, PATH_FOLDER].join('/') + '/';
  }
}
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function createTranslateLoader(http: HttpBackend): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(http, [
    { prefix: buildPath(BASE_PATH, PATH_COMMON), suffix: SUFFIX },
    { prefix: buildPath(BASE_PATH, PATH_PAGES, 'terms-and-conditions'), suffix: SUFFIX },
    { prefix: buildPath(BASE_PATH, PATH_PAGES, 'home'), suffix: SUFFIX },
    { prefix: buildPath(BASE_PATH, PATH_PAGES, 'settings'), suffix: SUFFIX },
    { prefix: buildPath(BASE_PATH, 'webServices'), suffix: SUFFIX },
  ]);
}

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private translate = inject(TranslateService);
  private common = inject(CommonService);
  private storage = inject(StorageService);

  langs: Array<{ text: string; value: string }> = [
    { text: 'Italiano', value: 'it' },
    { text: 'English', value: 'en' },
  ];

  constructor() {
    this.translate.addLangs(this.langs.map(({ value }) => value));
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en');
  }

  setLanguage(): void {
    this.storage
      .getFromStorage(StorageKey.Lang)
      .pipe(
        map((lang) => {
          if (!lang) {
            lang = window.navigator.language.split('-')[0];

            if (!['it', 'en'].includes(lang as string)) {
              lang = 'en';
            }
          }

          return lang as string;
        }),
      )
      .subscribe({
        next: (lang: string) => this.setCurrentLanguage(lang),
      });
  }

  setCurrentLanguage(lang: string): void {
    this.storage.setOnStorage(StorageKey.Lang, lang).subscribe();
    this.translate.use(lang);
    this.common.currentLang = lang;
  }

  instant(path: string): string {
    return this.translate.instant(path) as string;
  }
}
